import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EnvService } from 'src/app/services/env.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { SharedService } from 'src/app/services/shared.service';
import { responsedata, themeData } from 'src/interface/themesetting';
import { JournalService } from '../journal.service';
import { VolumeService } from 'src/app/services/volume.service';
import { volume } from 'src/interface/volumeIssue';
import { listAllarticle } from 'src/interface/article';
import { GetArticlesService } from 'src/app/services/get-articles.service';

@Component({
  selector: 'app-current-articles',
  templateUrl: './current-articles.component.html',
  styleUrls: ['./current-articles.component.scss']
})
export class CurrentArticlesComponent implements OnInit {
  themeSettingsData: themeData;
  journal_id = '';
  subscriptionArr: Subscription[] = [];
  volumesAndIssues: boolean;
  currentArticles: boolean;
  showCurrentArticlesOnly = false;
  volume_id = '';
  isPlatformBrowserStatus = false;
  journalId: string;
  thematicOnly = false;
  volumeData: volume[] = [];
  loading = true;
  volumDataLength = 0;
  volume_heading = ''
  articleCoverImageUrl: string;
  default_article_cover_image_upto_11: string;
  default_article_cover_image_above_11: string;
  current_article: any[] = [];


  constructor(private router: Router, private sharedService: SharedService,
    private mainBodyService: MainBodyService,
    @Inject(PLATFORM_ID) private platformId: any,
    private route: ActivatedRoute, private titleService: Title,
    private metatag: Meta,
    private EnvService: EnvService,
    private journalService: JournalService,
    private volumeService: VolumeService,
    private articleService: GetArticlesService
  ) {

  }
  ngOnInit(): void {
    this.default_article_cover_image_upto_11 = this.EnvService.default_article_cover_image_upto_11;
    this.default_article_cover_image_above_11 = this.EnvService.default_article_cover_image_above_11;
    // this.thematicOnly = this.route.snapshot.url.some(segment => segment.path === 'thematic-collections');
    // this.volumesAndIssues = this.route.snapshot.url.some(segment => segment.path === 'volumes');
    this.showCurrentArticlesOnly = this.route.snapshot.url.some(segment => segment.path === 'current-articles');



    const formattedStr = this.route.snapshot.url[0].path.split('-') // Split by hyphen
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(' ');

    this.titleService.setTitle(formattedStr + ' | ' + 'Journal of British Academy')
    this.metatag.updateTag(
      { property: 'og:title', content: formattedStr },
    );


    // Verify if you're getting the correct URL
    this.metatag.updateTag(
      { property: 'og:url', content: this.EnvService.siteUrl + this.route.snapshot.url[0].path },
    );

    this.volume_id = this.route.snapshot.params['volume_id'] != undefined ? this.route.snapshot.params['volume_id'] : this.volume_id;

    const journalidsubs = this.sharedService.getJournalId().subscribe(journalId => {
      this.journal_id = journalId;


      if (this.journalId == undefined) {

        const journalType = { jnl_type: "JNL" }
        const journaltypesubs = this.journalService.getJournals(journalType).subscribe((result) => {
          this.journal_id = result.data[0].id;
          this.articleCoverImageUrl =
            this.EnvService.articleCoverImage + this.journal_id + '/';
          this.metatag.updateTag(
            { property: 'og:type', content: result.data[0].journal_type.type },
          );

          this.metatag.updateTag(
            { property: 'og:image', content: this.EnvService.imageUrl + 'themes/' + result.data[0].journal_cover_image },
          );
          if (this.thematicOnly) {
            // this.volume_heading = 'app_header.special_issues_jba';
            const thematicSub = this.volumeService.getThematic(this.journal_id).subscribe(result => {
              if (result.data) {
                result.data = result.data.map(volume => {
                  if (volume.issue_issues && !Array.isArray(volume.issue_issues)) {
                    volume.issue_issues = Object.values(volume.issue_issues);
                  }
                  if (volume.non_issues && !Array.isArray(volume.non_issues)) {
                    volume.non_issues = Object.values(volume.non_issues);
                  }
                  return volume;
                });
              }
              this.volumeData = result.data;
              console.log(this.volumeData);

              // this.temporary_volume = this.volumeData;
              // this.volume_final = true;
              this.loading = false;

            })
            this.subscriptionArr.push(thematicSub);
          }
          if (!this.thematicOnly) {

            const volumeSub = this.volumeService.getVolumeIssues(this.journal_id).subscribe(result => {
              if (result.data) {
                result.data = result.data.map(volume => {
                  if (volume.issue_issues && !Array.isArray(volume.issue_issues)) {
                    volume.issue_issues = Object.values(volume.issue_issues);
                  }
                  if (volume.non_issues && !Array.isArray(volume.non_issues)) {
                    volume.non_issues = Object.values(volume.non_issues);
                  }
                  return volume;
                });
              }
              const latestissue = this.volumeService.getLatestIssue(this.journal_id).subscribe(value => {

                // this.temporary_volume = result.data;
                if (this.showCurrentArticlesOnly) {

                  // this.volume_final = true;
                  this.volume_heading = 'app_header.current_articles_jba';
                  // value.data holds the latest two published issues, ordered latest first
                  const latestIssues = value.data || [];
                  this.current_article = latestIssues.reduce((articles: any[], latestIssue) => {
                    const matchingVolume = result.data.find(volume => volume.volume === latestIssue['volume']);
                    const matchingIssue = matchingVolume?.issue_issues?.find(issue => issue.issue === latestIssue['issue']);
                    return matchingIssue?.articles ? articles.concat(matchingIssue.articles) : articles;
                  }, [] as any[]);


                  this.loading = false;

                }
                if (this.volume_id != '') {
                  this.volumeData = result.data.filter(volume => volume.volume === this.volume_id);
                  this.volumDataLength = this.volumeData.length
                  this.loading = false;
                }
                else {

                  this.volumeData = result.data;
                  this.volumDataLength = this.volumeData.length
                  this.loading = false;
                }
                console.log(this.volumeData);


              });
              this.subscriptionArr.push(latestissue);
            })
            this.subscriptionArr.push(volumeSub);

          }
          this.mainBodyService.urlchange(true);
          const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result: responsedata) => {
            this.themeSettingsData = result.data;
            if (isPlatformBrowser(this.platformId)) {
              Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                const element = "--" + key;
                const val: string = value;
                document.documentElement.style.setProperty(element, val);
              });
            }
          });
          this.subscriptionArr.push(getallthemesubs);
        });
        this.subscriptionArr.push(journaltypesubs);
      }

      // this.issue_cover_image = this.EnvService.articleCoverImage + this.journal_id + '/';


    });

    //  this.subscriptionArr.push(journalidsubs);
    // this.calculateContainerHeight();

    if (isPlatformBrowser(this.platformId)) {
      this.isPlatformBrowserStatus = true;
    }
    const url = this.route.params.subscribe(params => {
      this.sharedService.setUrlParams(params);
    });
    this.subscriptionArr.push(url);

  }
  goToPage(url: string) {
    this.router.navigate([url])
  }
  getAuthorsString(authors: any[]): string {

    if (authors.length === 0) return '';

    const authorNames = authors.map(author =>
      `${author.specific_use === "icwau" ? "in conversation with " : `${author.specific_use === "wffau" ? "with a Foreword from " : ""}`}${author.given_name} ${author.surname}`
    );
    return authorNames.join(', ');
  }
  removeCommaFromDate(date: string | undefined | null): string {
    if (!date) {
      return '';
    }

    return date.replace(/,/g, '');
  }
  getArticleImageUrl(oneArticle) {
    let url = '';
    url =
      oneArticle.volume +
      '/' +
      oneArticle.issue +
      '/' +
      oneArticle.article_id +
      '/' +
      oneArticle.article_cover_image;
    return url;
  }
  // Footnote xrefs in a title (e.g. <xref ref-type="fn" rid="fn1"><sup>1</sup></xref>)
  // are excluded entirely here, digit included, since this listing has no footnote
  // section/tooltip for the marker to refer to.
  private stripFootnoteXref(title: string): string {
    if (!title) {
      return title;
    }
    return title.replace(/<xref[^>]*ref-type=["']fn["'][^>]*>[\s\S]*?<\/xref>/gi, '');
  }

  getCleanTitle(title: string): string {
    return this.stripFootnoteXref(title).replace(/<[^>]*>/g, '');
  }

  // Preserves non-footnote superscript markers (e.g. <sup>2+</sup>) in article titles
  // while stripping every other tag, so numbers don't get appended as plain text.
  getFormattedTitle(title: string): string {
    if (!title) {
      return title;
    }
    return this.stripFootnoteXref(title)
      .replace(/<(?!\/?sup\b)[^>]*>/gi, '');
  }

  ensureHttps(url: string) {
    if (url != undefined) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return 'https://doi.org/' + url;
      }
      return url;
    }
    return url;
  }
}
